import React, { useEffect, useRef, useState } from 'react'
import { Todo } from '../model';
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { MdDone } from "react-icons/md";
import "./styles.css";
import { Draggable } from 'react-beautiful-dnd';

interface Props {
    index: number;
    todo: Todo;
    todos: Todo[];
    setTodos: React.Dispatch<React.SetStateAction<Todo[]>>;
}

const SingleTodo = ({ index, todo, todos, setTodos }: Props) => {
    const [edit, setEdit] = useState<boolean>(false);
    const [editTodo, setEditTodo] = useState<string>(todo.todo);

    function handleDone(key: number) {
        setTodos(todos.map((todo) => todo.id === key ? { ...todo, isDone: !todo.isDone } : todo));
    }

    function handleDelete(key: number) {
        setTodos(todos.filter((todo) => todo.id !== key));
    }

    function handleEdit(e: React.FormEvent<HTMLFormElement>, key: number) {
        e.preventDefault();
        if (editTodo !== "") {
            setTodos(todos.map((todo) => (
                todo.id === key ? { ...todo, todo: editTodo } : todo
            )));
            setEdit(false);
        }
    }

    useEffect(() => {
        inputRef.current?.focus();
    }, [edit]);

    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <Draggable draggableId={todo.id.toString()} index={index}>
            {
                (provided, snapshot) => (
                    <form
                        className={`todos__single ${snapshot.isDragging ? "drag" : ""}`}
                        onSubmit={(e) => handleEdit(e, todo.id)}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                    >
                        {
                            edit ? (
                                <input ref={inputRef} value={editTodo} onChange={(e) => setEditTodo(e.target.value)} className="todos__single--text" />
                            ) : todo.isDone ? (
                                <s className="todos__single--text">{todo.todo}</s>
                            ) : (
                                <span className="todos__single--text">{todo.todo}</span>
                            )
                        }
                        <div>
                            <span className="icon" onClick={() => {
                                if (!edit && !todo.isDone) {
                                    setEdit(!edit);
                                }
                            }}>
                                <AiFillEdit />
                            </span>
                            <span className="icon" onClick={() => handleDelete(todo.id)}>
                                <AiFillDelete />
                            </span>
                            <span className="icon" onClick={() => handleDone(todo.id)}>
                                <MdDone />
                            </span>
                        </div>
                    </form >

                )
            }
        </Draggable>
    )
}

export default SingleTodo;
